export interface ContentSize {
  width: number;
  height: number;
}

const REFERENCE_ASPECT_RATIO = 18 / 9;

export const calculateContentSize = (): ContentSize => {
  const screenWidth = window.innerWidth || document.documentElement.clientWidth;
  const screenHeight = window.innerHeight || document.documentElement.clientHeight;

  const currentAspectRatio = screenWidth / screenHeight;
  let contentWidth: number;
  let contentHeight: number;

  if (currentAspectRatio === REFERENCE_ASPECT_RATIO) {
    contentWidth = screenWidth;
    contentHeight = screenHeight;
  } else if (currentAspectRatio > REFERENCE_ASPECT_RATIO) {
    contentWidth = screenHeight * REFERENCE_ASPECT_RATIO;
    contentHeight = screenHeight;
  } else {
    contentWidth = screenWidth;
    contentHeight = screenWidth / REFERENCE_ASPECT_RATIO;
  }

  return { width: contentWidth, height: contentHeight };
};
